import { createContext, useContext } from 'react';

export const SiteVerificationContext = createContext(false);
export const useSiteVerified = () => useContext(SiteVerificationContext);
